/**
 * Kurz-Hinweise zu gängigen FinTS-TAN-Verfahren (HITAN TAN-Prozess laut HBCI/FinTS).
 * Ohne eindeutigen Code nur Heuristik (Bild-Challenge, push/decoupled).
 */
export function describeFintsTanProcedure(input: {
  decoupled: boolean;
  tanProcessCode: string | null;
  hasChallengeImage: boolean;
  /** BPD security function row (tan_process), falls HITAN keinen Code liefert */
  methodTanProcess?: string | null;
}): string {
  if (input.decoupled) {
    return 'pushTAN / App-TAN: Bitte die Freigabe in Ihrer Banking-App bestätigen. Oft ist keine manuelle TAN nötig.';
  }
  const raw = (input.tanProcessCode || input.methodTanProcess || '').trim();
  const c = raw.slice(0, 1);
  if (c === '2') {
    return 'mTAN (SMS-TAN): Geben Sie die TAN ein, die Sie per SMS auf Ihr Handy erhalten.';
  }
  if (c === '4' || c === '5') {
    return 'chipTAN (SmartTAN): Erzeugen Sie die TAN mit TAN-Generator und Bankkarte und geben Sie sie hier ein.';
  }
  if (c === '6' || c === '8') {
    return 'photoTAN / QR-TAN: Scannen Sie den Code mit Ihrer Banking-App oder folgen Sie der Anzeige.';
  }
  if (input.hasChallengeImage) {
    return 'photoTAN / QR-TAN: Nutzen Sie die Banking-App zum Scannen oder zur Auswertung des Bildes.';
  }
  return '';
}
